export const BookingWizardTabNames = {
	Search: 'Search',
	Date: 'Date',
	FindTickets: 'Find Tickets',
	ReviewTickets: 'Review Tickets',
	Tickets: 'Tickets',
	Customer: 'Customer',

	Contact: 'Contact',
	Shipment: 'Shipment',

	Vehicle: 'Vehicle',
	Passengers: 'Passengers',
	Seating: 'Seating',
	BookingDetails: 'Details',
	AddOns: 'Add ons',

	Reservation: 'Reservation',
	Cart: 'Cart',
	TermsAndConditions: 'Ts-and-Cs',
	Payment: 'Payment',
	PostPayment: 'Post Payment',
} as const;

export const TabNamesAfterReservation = [
	BookingWizardTabNames.Cart,
	BookingWizardTabNames.TermsAndConditions,
	BookingWizardTabNames.Payment,
	BookingWizardTabNames.PostPayment,
];
